// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1fnab","info":"UpdateTermsInfo_info__19rKi"};